import { request } from '@/utils/request';
import ENDPOINT from "@/config/endpoint";


function getUser(params) {
  return request({
    url: ENDPOINT.USERS_BACKEND,
    method: 'get',
    params,
  });
}

function updateUser(data) {
  return request({
    url: ENDPOINT.USERS_BACKEND,
    method: 'post',
    data,
  });
}

function getUserServices() {
  return request({
    url: ENDPOINT.USER_SERVICES,
    method: 'get',
  });
}

function getUserDiscount() {
  return request({
    url: `${ENDPOINT.USERS_DASHBOARD_BACKEND}/discounts`,
    method: 'get',
  });
}

function getAccountStatus() {
  return request({
    url: `${ENDPOINT.ACCOUNTS_BACKEND}/status`,
    method: 'get',
  });
}

function updateAccountStatus(data) {
  return request({
    url: `${ENDPOINT.ACCOUNTS_BACKEND}/status`,
    method: 'patch',
    data,
  });
}

function getInvoiceStatus() {
  return request({
    url: ENDPOINT.INVOICE_STATUS_BACKEND,
    method: 'get',
  });
}


export default {
  getUser,
  updateUser,
  getUserServices,
  getUserDiscount,
  getAccountStatus,
  updateAccountStatus,
  getInvoiceStatus,
};
